import React from 'react';

interface IProps {
    label: string;
    icon: React.ReactNode;
    hint?: React.ReactNode;
    className?: string;
    children: React.ReactNode;
}

// A labelled block of the booking form: small uppercase caption with an icon, the control, an optional hint.
export const Field: React.FC<IProps> = (props) => {
    const labelId = React.useId();

    return (
        <div
            className={['widget-field', props.className].filter(Boolean).join(' ')}
            role="group"
            aria-labelledby={labelId}
        >
            <div className="widget-field__label">
                {props.icon}
                <span id={labelId}>{props.label}</span>
            </div>
            {props.children}
            {props.hint && <div className="widget-field__hint">{props.hint}</div>}
        </div>
    );
};
